import { validateImage } from '@sketch/utils'

export default validateImage
